module.exports = __webpack_public_path__ + "media/images/patterns/header-profile-skin-3-d8e602140731b9734e5641f1ac310897.png";